import { StdResponse, request } from "@/global/config/request";

/**
 * 获取一组采集数据
 * @param id 采集设备id
 * @param matric 参数符号
 * @param type 类型 传感器 | 监测对象
 * @param startTime 开始时间
 * @param endTime  结束时间
 * @param samplingPeriod 采样周期
 * @param limit 采集点数上限
 * @param params 
 * @returns 
 */
export function queryInfluxDataList(id: number, metric: string, type: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/influx/${id}/data`, {
        params: {
            metric: metric,
            type: type,
            // startTime: startTime,
            // endTime: endTime,
            // samplingPeriod: samplingPeriod,
            // limit: limit,
            ...params,
        }
    })
}

/**
 * 获取最新数据
 * @param id 采集设备id
 * @param matric 参数符号
 * @param type 类型 传感器 | 监测对象
 * @param params 
 * @returns 
 */
export function queryInfluxCurrentData(id: number, metric: string, type: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/influx/${id}/current-data`, {
        params: {
            metric: metric,
            type: type,
            ...params,
        }
    })
}

export function queryConstitutiveData(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/constitutive`, {
        params: {
            ...params,
        }
    })
}
/**
 * 获得多个参数最新的数据
 * 
 * @return
 */
export function queryInfluxCurrentDataList(datas: any[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/influx/current-data`, datas, {
        params: {
            ...params,
        }
    })
}
